import React from 'react';
import ReactPaginate from 'react-paginate';

// handlePageChange: callback chamado com o novo número de página (1-indexado).
// currentPage (opcional, 1-indexado): quando informado, a página ativa é
// controlada pelo componente pai via forcePage, mantendo o destaque em sincronia
// com os dados realmente carregados (evita o botão ativo "travar" na página 1).
export default function PaginatedItems({ itemCount, itemsPerPage = 20, handlePageChange, currentPage }) {
    const pageCount = Math.ceil(itemCount / itemsPerPage);

    const handlePageClick = (event) => {
        handlePageChange(event.selected + 1);
        rolarParaOTopo();
    };

    // Rola para o começo da listagem ao trocar de página. No painel admin o
    // scroll é interno (.admin-main-content); nas telas públicas é a janela.
    // Rolar os dois cobre todos os layouts sem precisar de ajuste por tela.
    const rolarParaOTopo = () => {
        const conteudoAdmin = document.querySelector(".admin-main-content");
        if (conteudoAdmin) conteudoAdmin.scrollTo({ top: 0, behavior: "smooth" });
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <ReactPaginate
            breakLabel="..."
            nextLabel="Próximo"
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel="Anterior"
            forcePage={currentPage != null ? currentPage - 1 : undefined}
            renderOnZeroPageCount={null}
            containerClassName="pagination justify-content-center"
            activeClassName="active"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakClassName="page-item"
            breakLinkClassName="page-link"
        />
    );
}
